<!--
 * @Author: zyy
 * @Date: 2022-03-24 10:21:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-18 15:12:42
 * @Description: default
-->
<template>
  <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form>
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="工单编号" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="所属项目" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="工单来源" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="">
                <a-input v-model="complaintInitData.work_no" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-input v-model="resCommunityName" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-input v-model="complaintInitData.source" disabled />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="投诉类型" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="投诉时间" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="联系人" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="">
                <a-input v-model="complaintInitData.category" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-input v-model="complaintInitData.created_at" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-input v-model="complaintInitData.contacts" disabled />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="联系电话" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="工单状态" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="处理人" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="">
                <a-input v-model="complaintInitData.mobile" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-input v-model="finallyStatus" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <a-input v-model="resStaff" disabled />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="投诉内容" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="处理图片" style="margin-bottom: 0px">
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48" style="padding-bottom: 46px">
            <a-col :md="8" :sm="24">
              <a-form-item label="">
                <a-textarea rows="3" disabled v-model="complaintInitData.body" style="resize: none" />
              </a-form-item>
            </a-col>
            <a-col :md="16" :sm="24" style="padding-left: 9px">
              <a-form-item label="">
                <viewer :images="complaintInitData.handle_images">
                  <img v-for="src in complaintInitData.handle_images" :key="src" :src="src" width="70" height="70"
                    style="margin:0 3px;cursor:pointer">
                </viewer>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>

    <a-card style="margin-top: 20px">
      <H2 style="
          padding-bottom: 10px;
          border-bottom: 1px solid rgb(212, 203, 203);
          margin-bottom: 20px;
        ">工单轨迹</H2>
      <a-list item-layout="horizontal" :data-source="complaintInitData.logs">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-list-item-meta :description="`${item.operator} ${item.created_at} ${item.tips ? item.tips : ''
            } ${item.remarks ? item.remarks : ''}`">
            <a slot="title">{{ item.operation_content }}</a>
            <a-avatar slot="avatar" :src="item.avatar" />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-card>
    <a-card style="margin-top: 20px">
      <a-row :gutter="48">
        <a-col :md="24 || 24" :sm="24">
          <span class="table-page-search-submitButtons" :style="{ float: 'left', overflow: 'hidden' } || {}">
            <a-button type="primary" @click="handleAllot()" v-if="complaintInitData.status === 0">分配</a-button>
            <a-button style="margin-left: 8px" @click="cancelComplaint"
              v-if="modal2.closeType && (complaintInitData.status !== 5 && complaintInitData.status !== -1)">关闭</a-button>
            <a-button style="margin-left: 8px" @click="myGoBack" type="primary">返回</a-button>
          </span>
        </a-col>
      </a-row>
      <a-modal :title="modal1.title" :confirm-loading="modal1.loading" v-model="modal1.show" @ok="confirmModal1"
        destroy-on-close centered>
        <a-form-model ref="form" :model="modal1.subData" layout="vertical" :rules="modal1.rules">
          <a-form-model-item label="分配人员" prop='staff_id'>
            <a-select placeholder="请选择指派人" v-model="modal1.subData.staff_id">
              <a-select-option :value="value.id" v-for="value in modal1.initData.staffOptions" :key="value.id">{{
                value.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-modal :title="modal2.title" :confirm-loading="modal2.loading" v-model="modal2.show" @ok="confirmModal2"
        destroy-on-close centered>
        <a-form-model ref="form" :model="form" layout="vertical" :rules="rules2">
          <a-form-model-item label="关闭原因" prop='staff'>
            <a-textarea v-model="modal2.subData.cancelReason"></a-textarea>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import complaintListService from "@/io/complaint/complaintList.js";
import CommunityService from "@/io/community.js";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  data() {
    return {
      modal1: {
        title: '分配人员',
        show: false,
        loading: false,
        // 0新增，1编辑
        type: 0,
        subData: {
          staff_id: []
        },
        rules: {
          staff_id: [
            {
              required: true,
              message: "请选择分配人员",
            }
          ],
        },
        initData: {
          staffOptions: []
        }
      },
      modal2: {
        closeType: true,
        title: '关闭工单',
        show: false,
        loading: false,
        // 0新增，1编辑
        type: 0,
        subData: {
          cancelReason: null
        },
      },
      rules2: {},
      form: {},
      complaintInitData: {},
      previewVisible: false,
      previewImage: "",
    };
  },
  computed: {
    // 工单状态
    finallyStatus() {
      let strStatus = null;
      switch (this.complaintInitData.status) {
        case -1:
          strStatus = "已取消";
          break;
        case 0:
          strStatus = "待分配";
          break;
        case 1:
          strStatus = "已分配";
          break;
        case 2:
          strStatus = "待处理";
          break;
        case 3:
          strStatus = "处理中";
          break;
        case 4:
          strStatus = "未办结";
          break;
        case 5:
          strStatus = "已办结";
          break;
        default:
          strStatus = "暂无信息";
          break;
      }
      return strStatus;
    },
    // 分配人
    resStaff() {
      return this.initDetailData.staff
        ? this.initDetailData.staff.name
        : "暂无信息";
    },
    // 项目名称
    resCommunityName() {
      return this.complaintInitData.community
        ? this.complaintInitData.community.name
        : "暂无信息";
    },
    // 图片列表数据
    imagesList() {
      let resImagesList = [];
      if (this.initDetailData.images) {
        this.initDetailData.images.map((val, index) => {
          resImagesList.push({
            uid: `zyyxxx${index}`,
            name: `zyyxxx${index}.png`,
            status: "done",
            url: val,
          });
        });
      }
      // else {
      //   resImagesList.push({
      //     uid: "-4",
      //     name: "image.png",
      //     status: "done",
      //     url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
      //   });
      // }
      return resImagesList;
    },
  },
  mounted() {
    this.initDetailData();
    // this.getStaffOptions()
  },
  methods: {

    //   初始化页面数据
    async initDetailData() {
      // const res = this.resDetailData
      const res = await complaintListService.detail(this.$route.params.id)
      this.complaintInitData = res;

      const staffRes = await CommunityService.staff(this.complaintInitData.community ? this.complaintInitData.community.id : null);
      this.modal1.initData.staffOptions = staffRes;
    },
    confirmModal1() {
      this.$beforeFormSubmit(this.$refs.form, async () => {
        const res = await complaintListService.assign(this.$route.params.id, this.modal1.subData.staff_id)
        console.log(res)
        this.$afterFormSubmit("修改成功", () => {
          this.modal1.show = false;
          this.modal1.loading = false;
        });
      });
    },
    confirmModal2() {
      this.$beforeFormSubmit(this.$refs.form, async () => {
        // this.modal2.loading = true;
        const res = await complaintListService.cancel(this.$route.params.id, this.modal2.subData.cancelReason)
        // console.log(res)
        this.$afterFormSubmit("修改成功", () => {
          this.modal2.closeType = false
          this.modal2.show = false;
          this.modal2.loading = false;

        });
      });
    },
    // 关闭工单
    cancelComplaint() {
      this.modal2.show = true
    },
    // 关闭图片
    handleCancel() {
      this.previewVisible = false;
    },
    // 预览图片
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    // 分配
    async handleAllot() {

      this.modal1.show = true
    },
    myGoBack() {
      this.$router.push("/platform/complaintlist");
    },
  },
};
</script>

<style>
/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.bottomcontainer {
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  margin-top: 20px;
  box-shadow: 0 4px 16px 0 rgba(38, 38, 38, 0.12);
}
</style>
